// 消息模块 - 处理系统消息、通知等

const state = {
  messages: [],
  unreadCount: 0,
  loading: false
};

const getters = {
  allMessages: state => state.messages,
  unreadMessages: state => state.messages.filter(m => !m.read),
  unreadCount: state => state.unreadCount
};

const mutations = {
  SET_MESSAGES(state, messages) {
    state.messages = messages;
    state.unreadCount = messages.filter(m => !m.read).length;
  },
  ADD_MESSAGE(state, message) {
    state.messages.unshift(message);
    if (!message.read) {
      state.unreadCount++;
    }
  },
  MARK_AS_READ(state, messageId) {
    const message = state.messages.find(m => m.id === messageId);
    if (message && !message.read) {
      message.read = true;
      state.unreadCount--;
    }
  },
  MARK_ALL_AS_READ(state) {
    state.messages.forEach(m => {
      m.read = true;
    });
    state.unreadCount = 0;
  },
  DELETE_MESSAGE(state, messageId) {
    const index = state.messages.findIndex(m => m.id === messageId);
    if (index !== -1) {
      if (!state.messages[index].read) {
        state.unreadCount--;
      }
      state.messages.splice(index, 1);
    }
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  }
};

const actions = {
  // 获取消息列表
  async fetchMessages({ commit }) {
    commit('SET_LOADING', true);
    try {
      // TODO: 调用 API 获取消息
      // const response = await api.get('/messages');
      // commit('SET_MESSAGES', response.data);
      
      // 模拟数据
      commit('SET_MESSAGES', [
        {
          id: 1,
          type: 'order',
          title: '新订单通知',
          content: '您有一个新的采购订单待处理',
          read: false,
          createTime: Date.now()
        },
        {
          id: 2,
          type: 'system',
          title: '系统通知',
          content: '系统将于今晚 22:00 进行维护',
          read: true,
          createTime: Date.now() - 86400000
        }
      ]);
    } catch (error) {
      console.error('获取消息失败:', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 添加消息
  addMessage({ commit }, message) {
    commit('ADD_MESSAGE', {
      id: Date.now(),
      read: false,
      createTime: Date.now(),
      ...message
    });
  },

  // 标记为已读
  markAsRead({ commit }, messageId) {
    commit('MARK_AS_READ', messageId);
  },

  // 全部标记为已读
  markAllAsRead({ commit }) {
    commit('MARK_ALL_AS_READ');
  },

  // 删除消息
  deleteMessage({ commit }, messageId) {
    commit('DELETE_MESSAGE', messageId);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
